exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head[data-v-35c4be93],\n.content[data-v-35c4be93] {\n  width: 100%;\n}\n.head[data-v-35c4be93] {\n  padding-bottom: 10px;\n}\n.content[data-v-35c4be93] {\n  display: flex;\n  justify-content: space-between;\n}\n.content .info span[data-v-35c4be93] {\n    display: inline-block;\n    width: 100%;\n}\n.content .actions[data-v-35c4be93] {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n.content .actions button[data-v-35c4be93] {\n      margin-left: 20px;\n}\n.foot[data-v-35c4be93] {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 10px;\n}\n", ""]);

// exports
